import { Injectable } from '@angular/core';
import { SlugifyPipe } from '../pipes/slugify.pipe';
import { CountryItem } from '../../api/models';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  constructor(private slugPipe: SlugifyPipe) {}

  country(c: CountryItem) {
    return ['/viaggi-di-gruppo/', c.ISO, this.slugPipe.transform(c.name)];
  }
}
